import React from "react";
import { Card } from "reactstrap";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { ChatBubbleBottomCenterIcon, CheckBadgeIcon, CurrencyEuroIcon, LockClosedIcon, QuestionMarkCircleIcon, UserCircleIcon } from "@heroicons/react/24/solid";


export const CardS = styled(Card)`
background: rgb(234 244 243) !important;
border-radius: 20px;
border: 0;
margin-bottom: 2rem;
margin-top: 2rem;
 color:#fff;
 display:flex;
 flex-direction:row!important;
 align-items:center;
 justify-content:space-between;
 padding: 2rem;
 .card-title{
    font-size:24px;
    color:black;
 }
 @media all and (max-width: 768px) {
    flex-direction:column!important;
    .card-title{
        font-size:18px;
     }
  }
`;


function CardClotere1(args) {
    return (
        <>
        {args.type === "achat" && <>
            <div className="text-left ">
                <h5 className="font-bold text-lg"><b> Clotere vous accompagne pour votre achat immobilier chez le notaire</b></h5>
                <p>Des étapes et un suivi transparent pour tout comprendre à votre achat immo</p>
                <ul>
                    <li className="flex items-center gap-3 font-semibold"><UserCircleIcon className="size-10 text-indigo-500"/>Choisissez votre notaire</li>
                    <li className="flex items-center gap-3 font-semibold"><LockClosedIcon className="size-10 text-indigo-500"/>Constituez votre dossier en ligne simplement</li>
                    <li className="flex items-center gap-3 font-semibold"><QuestionMarkCircleIcon className="size-10 text-indigo-500"/>Posez toutes vos questions à votre conseiller dédié Clotere</li>
                    <li className="flex items-center gap-3 font-semibold"><CheckBadgeIcon className="size-10 text-indigo-500"/>Signez quand vous êtes prêt 🙂</li>
                </ul>
                <div className="flex flex-row justify-start gap-4 flex-wrap">
                <Link to="/onboard/achat" className="btn-main no-underline text-white mb-2">
                        Trouvez votre notaire pour votre achat immobilier
                    </Link>
                    </div>
                </div>
            </>}
            {args.type === "vente" && <>
            <div className="text-left ">
                <h5 className="font-bold text-lg"><b> Clotere vous accompagne pour votre vente immobilière chez le notaire</b></h5>
                <p>Des étapes et un suivi transparent pour tout comprendre à votre achat immo</p>
                <ul>
                    <li className="flex items-center gap-3 font-semibold"><UserCircleIcon className="size-10 text-indigo-500"/>Choisissez votre notaire</li>
                    <li className="flex items-center gap-3 font-semibold"><LockClosedIcon className="size-10 text-indigo-500"/>Obtenez la liste des documents obligatoires chez le notaire</li>
                    <li className="flex items-center gap-3 font-semibold"><QuestionMarkCircleIcon className="size-10 text-indigo-500"/>Posez toutes vos questions à votre conseiller dédié Clotere</li>
                    <li className="flex items-center gap-3 font-semibold"><CheckBadgeIcon className="size-10 text-indigo-500"/>Fixez vos rendez-vous de signature simplement</li>
                </ul>
                <div className="flex flex-row justify-start gap-4 flex-wrap">
                <Link to="/onboard/vente" className="btn-main no-underline text-white mb-2">
                        Trouvez votre notaire pour votre vente immobilière
                    </Link>
                    </div>
                </div>
            </>}
        {args.type === "mariage" && <>
            <div className="text-left ">
                <h5 className="font-bold text-lg"><b> Clotere vous accompagne pour votre contrat de mariage chez le notaire</b></h5>
                <p>Des étapes et un suivi transparent pour tout comprendre à votre contrat de mariage</p>
                <ul>
                    <li className="flex items-center gap-3 font-semibold"><UserCircleIcon className="size-10 text-indigo-500"/>Choisissez votre notaire</li>
                    <li className="flex items-center gap-3 font-semibold"><ChatBubbleBottomCenterIcon className="size-10 text-indigo-500"/>Echangez avec lui gratuitement lors d'un premier rendez-vous</li>
                    <li className="flex items-center gap-3 font-semibold"><CurrencyEuroIcon className="size-10 text-indigo-500"/>Obtenez un tarif précis selon votre situation</li>
                    <li className="flex items-center gap-3 font-semibold"><LockClosedIcon className="size-10 text-indigo-500"/>Constituez votre dossier en ligne simplement</li>
                    <li className="flex items-center gap-3 font-semibold"><CheckBadgeIcon className="size-10 text-indigo-500"/>Signez quand vous êtes prêt 🙂</li>
                </ul>
                <div className="flex flex-row justify-start gap-4 flex-wrap">
                <Link to="/onboard/mariage" className="btn-main no-underline text-white mb-2">
                        Débutez votre contrat de mariage
                    </Link>
                    </div>
                </div>
            </>}
            {args.type === "pacs" && <>
            <div className="text-left ">
                <h5 className="font-bold text-lg"><b> Clotere vous accompagne pour votre convention de PACS chez le notaire</b></h5>
                <p>Des étapes et un suivi transparent pour tout comprendre à votre PACS</p>
                <ul>
                    <li className="flex items-center gap-3 font-semibold"><UserCircleIcon className="size-8 text-indigo-500"/>Choisissez votre notaire</li>
                    <li className="flex items-center gap-3 font-semibold"><ChatBubbleBottomCenterIcon className="size-8 text-indigo-500"/>Echangez avec lui gratuitement lors d'un premier rendez-vous</li>
                    <li className="flex items-center gap-3 font-semibold"><CurrencyEuroIcon className="size-8 text-indigo-500"/>Obtenez un tarif précis selon votre situation</li>
                    <li className="flex items-center gap-3 font-semibold"><LockClosedIcon className="size-8 text-indigo-500"/>Constituez votre dossier en ligne simplement</li>
                    <li className="flex items-center gap-3 font-semibold"><CheckBadgeIcon className="size-8 text-indigo-500"/>Signez quand vous êtes prêt 🙂</li>
                </ul>
                <div className="flex flex-row justify-start gap-4 flex-wrap">
                <Link to="/onboard/pacs" className="btn-main no-underline text-white mb-2">
                        Débutez votre convention de PACS
                    </Link>
                    </div>
                </div>
            </>}
        {!args.type && <>
        <div className="text-left border-4 p-4 rounded-lg border-emerald-100">
        <h5 className="font-bold text-lg"><b> Clotere vous accompagne dans vos démarches chez le notaire : faire une <span className="font-bold text-[#1DF36C]">donation</span>, trouver un <span className="font-bold text-[#1DF36C]">notaire acheteur</span>, confier <span className="font-bold text-[#1DF36C]">la vente de son bien immobilier à un notaire</span>, etc </b></h5>
        <p>Constituez et suivez simplement votre dossier notaire avec Clotere.</p>
        <div className="flex flex-row justify-center gap-4 flex-wrap">
        <Link to="/faire-une-donation" className="btn-main no-underline text-white mb-2">
                Faire une donation
            </Link>
            <Link to="/inscription/achat" className="btn-main no-underline text-white  mb-2">
                Acheter son logement
            </Link>
            <Link to="/inscription/vente" className="btn-main no-underline text-white mb-2">
                Vendre son bien
            </Link>
            </div>
        </div>
        </>}
        </>
    );
}

export default CardClotere1;